import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-3" }
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-3" }
const _hoisted_11 = { class: "col p-0" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "form-group mb-2 me-2 col-md-5 col-lg-5 col-xl-5" }
const _hoisted_15 = { class: "d-flex align-items-center gap-1" }
const _hoisted_16 = { class: "col-sm-3 col-form-label text-capitalize-first p-0 me-1" }
const _hoisted_17 = {
  key: 0,
  class: "w-100"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "form-group mb-2 me-2 col-md-5 col-lg-5 col-xl-5" }
const _hoisted_20 = { class: "d-flex align-items-center gap-1" }
const _hoisted_21 = { class: "col-sm-3 col-form-label text-capitalize-first p-0 me-1" }
const _hoisted_22 = {
  key: 0,
  class: "w-100"
}
const _hoisted_23 = { class: "form-group mb-2 col" }
const _hoisted_24 = { class: "col-auto p-0 text-end" }
const _hoisted_25 = { class: "col-sm-12" }
const _hoisted_26 = { class: "card card-body" }
const _hoisted_27 = { class: "overflow-auto" }
const _hoisted_28 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_29 = { class: "text-capitalize-first" }
const _hoisted_30 = { class: "text-capitalize-first" }
const _hoisted_31 = { class: "text-capitalize-first" }
const _hoisted_32 = { class: "text-capitalize-first" }
const _hoisted_33 = { class: "text-capitalize-first" }
const _hoisted_34 = { class: "text-capitalize-first" }
const _hoisted_35 = { class: "text-end" }
const _hoisted_36 = { class: "d-flex flex-column" }
const _hoisted_37 = { class: "text-secondary" }
const _hoisted_38 = {
  key: 3,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_39 = {
  class: "d-flex",
  style: {"clear":"both"}
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 3,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_42 = {
  class: "d-flex",
  style: {"clear":"both"}
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 0,
  class: "text-end"
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_48 = { class: "text-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_MerchantMultiselect = _resolveComponent("MerchantMultiselect")!
  const _component_InternalTransferForm = _resolveComponent("InternalTransferForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_AccountWidget = _resolveComponent("AccountWidget")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_BalanceCorrectionModal = _resolveComponent("BalanceCorrectionModal")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_Multiselect, {
                          id: "statuses",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.statuses,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.statuses) = $event)),
                          options: Object.values(_ctx.InternalTransferRequestStatus).filter(item => item === parseInt(item)),
                          "custom-label": (opt) => _ctx.helper.trans(`internal_transfer_request_status.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.status')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_MerchantMultiselect, {
                          multiple: true,
                          modelValue: _ctx.merchantsFilter,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.merchantsFilter) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.helper.trans("labels.from_account")) + ":", 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-outline-dark text-capitalize-first",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleFromType()), ["prevent"]))
                      }, _toDisplayString(_ctx.fromAccountType ? _ctx.helper.trans(`labels.${_ctx.fromAccountType}`) : _ctx.helper.trans(`labels.select`)), 1),
                      (_ctx.fromAccountType && _ctx.fromAccountType !== 'system')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_Multiselect, {
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.fromAccount,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.fromAccount) = $event)),
                              options: _ctx.fromAccounts,
                              "custom-label": (opt) => _ctx.labelFor(_ctx.fromAccountType!, opt),
                              "track-by": "id",
                              "select-label": "Select",
                              "open-direction": "bottom",
                              multiple: false,
                              searchable: true,
                              loading: _ctx.isLoading,
                              "internal-search": false,
                              "clear-on-select": true,
                              "close-on-select": true,
                              "options-limit": 100,
                              limit: 1000,
                              "show-no-results": false,
                              "hide-selected": false,
                              onSearchChange: _ctx.asyncFindFromAccounts
                            }, null, 8, ["modelValue", "options", "custom-label", "loading", "onSearchChange"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.fromAccountType)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-sm btn-link",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.clearFromType()), ["prevent"]))
                          }, _cache[19] || (_cache[19] = [
                            _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.helper.trans("labels.to_account")) + ":", 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-outline-dark text-capitalize-first",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.toggleToType()), ["prevent"]))
                      }, _toDisplayString(_ctx.toAccountType ? _ctx.helper.trans(`labels.${_ctx.toAccountType}`) : _ctx.helper.trans(`labels.select`)), 1),
                      (_ctx.toAccountType && _ctx.toAccountType !== 'system')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode(_component_Multiselect, {
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.toAccount,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.toAccount) = $event)),
                              options: _ctx.toAccounts,
                              "custom-label": (opt) => _ctx.labelFor(_ctx.toAccountType!, opt),
                              "track-by": "id",
                              "select-label": "Select",
                              "open-direction": "bottom",
                              multiple: false,
                              searchable: true,
                              loading: _ctx.isLoading,
                              "internal-search": false,
                              "clear-on-select": true,
                              "close-on-select": true,
                              "options-limit": 100,
                              limit: 1000,
                              "show-no-results": false,
                              "hide-selected": false,
                              onSearchChange: _ctx.asyncFindToAccounts
                            }, null, 8, ["modelValue", "options", "custom-label", "loading", "onSearchChange"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.toAccountType)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-sm btn-link",
                            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.clearToType()), ["prevent"]))
                          }, _cache[20] || (_cache[20] = [
                            _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(() => _ctx.exportData(), ["prevent"])),
                        class: "btn btn-outline-success btn-sm rounded-pill me-2 text-capitalize-first"
                      }, [
                        _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fa fa-download me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.helper.trans('button.export')), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[9] || (_cache[9] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      (_ctx.isAdmin && _ctx.store.getters.hasPermission(_ctx.UserPermission.BALANCE_CORRECTION))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.openBalanceCorrection()), ["prevent"])),
                            class: "btn btn-outline-dark btn-sm rounded-pill text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('button.balance_correction')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[11] || (_cache[11] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("table", _hoisted_28, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                        _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.helper.trans('labels.created')), 1),
                        _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.helper.trans("labels.from_account")), 1),
                        _cache[22] || (_cache[22] = _createElementVNode("th", { class: "text-capitalize-first" }, null, -1)),
                        _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.helper.trans("labels.to_account")), 1),
                        _cache[23] || (_cache[23] = _createElementVNode("th", { class: "text-capitalize-first" }, null, -1)),
                        _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                        _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.helper.trans("labels.status")), 1),
                        _createElementVNode("th", _hoisted_35, [
                          (!_ctx.isOperatorRestricted)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showEditModal())),
                                class: "btn btn-outline-primary btn-sm text-capitalize"
                              }, _toDisplayString(_ctx.helper.trans('button.create')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(_component_b_modal, {
                            "dialog-class": "modal-lg",
                            title: _ctx.helper.trans('labels.create_internal_transfer_request'),
                            modelValue: _ctx.createModal,
                            "body-class": "pt-0",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.createModal = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InternalTransferForm, { ref: "createForm" }, null, 512)
                            ]),
                            footer: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.createModal = false)),
                                class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                              }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                              _createVNode(_component_LoaderWrapper, {
                                ref: "loaderCreateFrom",
                                zoom: 0.5
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.save())),
                                    class: "btn btn-outline-primary btn-sm text-capitalize-first"
                                  }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                                ]),
                                _: 1
                              }, 512)
                            ]),
                            _: 1
                          }, 8, ["title", "modelValue"])
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id,
                          class: ""
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("span", null, _toDisplayString(item.id), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_36, [
                              (item._createdBy)
                                ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                    key: 0,
                                    "show-badge": "",
                                    user: item._createdBy
                                  }, null, 8, ["user"]))
                                : _createCommentVNode("", true),
                              _createElementVNode("small", _hoisted_37, _toDisplayString(_ctx.dateHelper.format(item.createdAt)), 1)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            (item._fromSystemAccount)
                              ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                  key: 0,
                                  "show-badge": "",
                                  user: _ctx.systemUser
                                }, null, 8, ["user"]))
                              : _createCommentVNode("", true),
                            (item._fromTraderAccount)
                              ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                  key: 1,
                                  "show-badge": "",
                                  user: item._fromTraderAccount.user
                                }, null, 8, ["user"]))
                              : _createCommentVNode("", true),
                            (item._fromUserAccount)
                              ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                  key: 2,
                                  "show-badge": "",
                                  user: item._fromUserAccount.user
                                }, null, 8, ["user"]))
                              : _createCommentVNode("", true),
                            (item._fromMerchantStoreAccount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_UserNameLabel, {
                                      "show-badge": "",
                                      user: item._fromMerchantStoreAccount.user
                                    }, null, 8, ["user"]),
                                    _createElementVNode("div", _hoisted_39, _toDisplayString(item._fromMerchantStoreAccount?.storeName), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (item.status === _ctx.InternalTransferRequestStatus.STATUS_NEW)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  (item._fromTraderAccount)
                                    ? (_openBlock(), _createBlock(_component_AccountWidget, {
                                        key: 0,
                                        account: item._fromTraderAccount.account
                                      }, null, 8, ["account"]))
                                    : _createCommentVNode("", true),
                                  (item._fromMerchantStoreAccount)
                                    ? (_openBlock(), _createBlock(_component_AccountWidget, {
                                        key: 1,
                                        account: item._fromMerchantStoreAccount.account
                                      }, null, 8, ["account"]))
                                    : _createCommentVNode("", true),
                                  (item._fromUserAccount)
                                    ? (_openBlock(), _createBlock(_component_AccountWidget, {
                                        key: 2,
                                        account: item._fromUserAccount.account
                                      }, null, 8, ["account"]))
                                    : _createCommentVNode("", true),
                                  (item._fromSystemAccount)
                                    ? (_openBlock(), _createBlock(_component_AccountWidget, {
                                        key: 3,
                                        account: item._fromSystemAccount
                                      }, null, 8, ["account"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (item._toSystemAccount)
                              ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                  key: 0,
                                  "show-badge": "",
                                  user: _ctx.systemUser
                                }, null, 8, ["user"]))
                              : _createCommentVNode("", true),
                            (item._toTraderAccount)
                              ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                  key: 1,
                                  "show-badge": "",
                                  user: item._toTraderAccount.user
                                }, null, 8, ["user"]))
                              : _createCommentVNode("", true),
                            (item._toUserAccount)
                              ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                  key: 2,
                                  "show-badge": "",
                                  user: item._toUserAccount.user
                                }, null, 8, ["user"]))
                              : _createCommentVNode("", true),
                            (item._toMerchantStoreAccount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_UserNameLabel, {
                                      "show-badge": "",
                                      user: item._toMerchantStoreAccount.user
                                    }, null, 8, ["user"]),
                                    _createElementVNode("div", _hoisted_42, _toDisplayString(item._toMerchantStoreAccount?.storeName), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (item.status === _ctx.InternalTransferRequestStatus.STATUS_NEW)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                  (item._toTraderAccount)
                                    ? (_openBlock(), _createBlock(_component_AccountWidget, {
                                        key: 0,
                                        account: item._toTraderAccount.account
                                      }, null, 8, ["account"]))
                                    : _createCommentVNode("", true),
                                  (item._toMerchantStoreAccount)
                                    ? (_openBlock(), _createBlock(_component_AccountWidget, {
                                        key: 1,
                                        account: item._toMerchantStoreAccount.account
                                      }, null, 8, ["account"]))
                                    : _createCommentVNode("", true),
                                  (item._toUserAccount)
                                    ? (_openBlock(), _createBlock(_component_AccountWidget, {
                                        key: 2,
                                        account: item._toUserAccount.account
                                      }, null, 8, ["account"]))
                                    : _createCommentVNode("", true),
                                  (item._toSystemAccount)
                                    ? (_openBlock(), _createBlock(_component_AccountWidget, {
                                        key: 3,
                                        account: item._toSystemAccount
                                      }, null, 8, ["account"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatMoney(item.sum, 2)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`internal_transfer_request_status.${item.status}`)), 1),
                          _createElementVNode("td", null, [
                            (item.status === _ctx.InternalTransferRequestStatus.STATUS_NEW)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                  (!_ctx.isOperatorRestricted || _ctx.store.getters.hasPermission(_ctx.UserPermission.INTERNAL_TRANSFER))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.cancel(item.id)),
                                        class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"
                                      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 9, _hoisted_45))
                                    : _createCommentVNode("", true),
                                  (_ctx.isAdmin || _ctx.isOperator && _ctx.store.getters.hasPermission(_ctx.UserPermission.INTERNAL_TRANSFER))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        disabled: item.createdById === _ctx.user.id,
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.process(item.id)),
                                        class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                                      }, _toDisplayString(_ctx.helper.trans('button.transfer')), 9, _hoisted_46))
                                    : _createCommentVNode("", true)
                                ]))
                              : (item.updatedAt)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    (item._updatedBy)
                                      ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                          key: 0,
                                          "show-badge": "",
                                          user: item._updatedBy
                                        }, null, 8, ["user"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("small", _hoisted_48, _toDisplayString(_ctx.dateHelper.format(item.updatedAt)), 1)
                                  ]))
                                : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.response.totalCount > _ctx.response.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[16] || (_cache[16] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[17] || (_cache[17] = ($event: any) => (_ctx.load()))
                        ],
                        "total-rows": _ctx.response.totalCount,
                        "per-page": _ctx.response.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512),
      _createVNode(_component_BalanceCorrectionModal, {
        showModal: _ctx.balanceCorrectionModal,
        "onUpdate:showModal": _cache[18] || (_cache[18] = ($event: any) => (_ctx.balanceCorrectionModal = $event)),
        onSuccess: _ctx.load
      }, null, 8, ["showModal", "onSuccess"])
    ]),
    _: 1
  }, 512))
}